import api from 'api';
export const FONTS_ASYNC_ACTION_START = 'FONTS_ASYNC_ACTION_START';
export const FONTS_ASYNC_ACTION_SUCCESS = 'FONTS_ASYNC_ACTION_SUCCESS';
export const FONTS_ASYNC_ACTION_ERROR = 'FONTS_ASYNC_ACTION_ERROR';

function fontsAsyncActionStart() {
    return {
        type: FONTS_ASYNC_ACTION_START,
    };
}

function fontsAsyncActionSuccess(data) {
    return {
        type: FONTS_ASYNC_ACTION_SUCCESS,
        data,
    };
}

function fontsAsyncActionError(error) {
    return {
        type: FONTS_ASYNC_ACTION_ERROR,
        error,
    };
}

/**
 * fetch common fonts
 * @returns fontlist
 */
export const getCommonFonts = () => {
    return (dispatch) => {
        dispatch(fontsAsyncActionStart());
        return api.request('fonts?fontType=COMMON', 'get')
            .then((data) => {
                dispatch(fontsAsyncActionSuccess(data));
                return data;
            })
            .catch((err) => {
                dispatch(fontsAsyncActionError('Unable to get common fonts list'));
                throw (err);
            });
    };
}